var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamAtendeFacil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7188 15.2625C2.3188 15.2625 1.97192 15.1156 1.67817 14.8219C1.38442 14.5281 1.23755 14.1812 1.23755 13.7812V4.21875C1.23755 3.81875 1.38442 3.46875 1.67817 3.16875C1.97192 2.86875 2.3188 2.71875 2.7188 2.71875H12.2813C12.6813 2.71875 13.0313 2.86875 13.3313 3.16875C13.6313 3.46875 13.7813 3.81875 13.7813 4.21875V8.15625L16.125 5.8125C16.25 5.6875 16.3907 5.65625 16.5469 5.71875C16.7032 5.78125 16.7813 5.89375 16.7813 6.05625V11.925C16.7813 12.1 16.7032 12.2188 16.5469 12.2812C16.3907 12.3438 16.25 12.3125 16.125 12.1875L13.7813 9.84375V13.7812C13.7813 14.1812 13.6313 14.5281 13.3313 14.8219C13.0313 15.1156 12.6813 15.2625 12.2813 15.2625H2.7188Z",
    fill: "#222529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamAtendeFacil);
export default __webpack_public_path__ + "static/media/icon_cam_atende_facil.d1b60e0dc38c8d39a7e887fd7c814b76.svg";
export { ForwardRef as ReactComponent };